/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import { forwardRef } from "react";
import { Dialog, DialogContent, DialogTitle, IconButton, Slide } from "@material-ui/core";
import CancelIcon from "@material-ui/icons/Cancel";
import DescriptionIcon from "@material-ui/icons/Description";
import EventIcon from "@material-ui/icons/Event";
import initCapitalize from "../../../../utils/commonFunctions/initCapitalize";
import { dateTimeZoneConverter } from "../../../../utils/commonFunctions/date";

import "./customImageDialogWithTitle.css";

const Transition = forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const CustomImageDialogWithTitle = ({
	dialogProps: { openDialog, image },
	handleImageDialogClose,
	eventName,
	eventDate
}) => {
	return (
		<Dialog
			fullScreen={false}
			style={{ zIndex: 60000 }}
			open={openDialog}
			TransitionComponent={Transition}
			keepMounted
			aria-labelledby="alert-dialog-slide-title"
			aria-describedby="alert-dialog-slide-description"
			onClose={handleImageDialogClose}
			maxWidth="md"
		>
			<DialogTitle>
				<div
					className="dialog-title-container"
					style={{
						padding: "10px",
						justifyContent: "space-between",
						display: "flex",
						alignItems: "center"
					}}
				>
					<div className="wrap-container">
						<div className="event-name-container">
							<DescriptionIcon className="event-name-icon" />
							<span className="event-name">{eventName ? initCapitalize(eventName) : ""}</span>
						</div>

						<div className="dialog-title-date-container">
							<EventIcon className="dialog-title-date-icon" />
							<span id="dialog-title-date">{eventDate ? dateTimeZoneConverter(eventDate) : ""}</span>
						</div>
					</div>

					<span>
						<IconButton aria-label="close" onClick={handleImageDialogClose}>
							<CancelIcon fontSize="medium" />
						</IconButton>
					</span>
				</div>
			</DialogTitle>

			<DialogContent className="dialog-content">
				<img src={image} width="100%" height="100%" alt="event_document" />
			</DialogContent>
		</Dialog>
	);
};

export default CustomImageDialogWithTitle;
